import { Injectable } from '@angular/core';

import { Store } from '@ngrx/store';
import { Observable, Subject } from 'rxjs';
import { map } from 'rxjs/operators';

import {
  AsyncJobActions,
  AsyncJobSelectors,
  AsyncJobService,
  AsyncJobStatus,
} from '@recruitee/async-job-data';
import { DialogRef, DialogService, DialogWidth } from '@recruitee/user-interface';

import { AsyncJobViewModel } from '../async-job-view.types';
import { AsyncJobsDialogComponent } from '../components/async-jobs-dialog/async-jobs-dialog.component';
import { AsyncJobConfigService } from '../configs/async-job-config.service';
import { AsyncJobViewModelService } from './async-job-view-model.service';

@Injectable({ providedIn: 'root' })
export class AsyncJobDialogService {
  public dialogClosed$ = new Subject<void>();
  private dialogRef: DialogRef<AsyncJobsDialogComponent> | undefined = undefined;

  constructor(
    private asyncJobConfig: AsyncJobConfigService,
    private asyncJobService: AsyncJobService,
    private dialogService: DialogService,
    private asyncJobViewModelService: AsyncJobViewModelService,
    private store: Store,
  ) {}

  public show(): void {
    this.openDialog();
  }

  public isOpen() {
    return !!this.dialogRef;
  }

  private openDialog() {
    const data$: Observable<AsyncJobViewModel[]> = this.store
      .select(AsyncJobSelectors.allEntities)
      .pipe(
        map(jobs =>
          jobs.filter(
            job =>
              job.status !== AsyncJobStatus.IDLE &&
              (this.asyncJobConfig.get(job).showDialog || job.errors.length),
          ),
        ),
        map(jobs => jobs.map(job => this.asyncJobViewModelService.create(job))),
      );

    this.dialogRef = this.dialogService.custom(
      AsyncJobsDialogComponent,
      { width: DialogWidth.SmallXX },
      data$,
    );

    this.dialogRef.afterClosed.subscribe(() => {
      this.dialogRef = undefined;
      this.store.dispatch(AsyncJobActions.clearFinished());
      this.dialogClosed$.next();
    });
  }
}
